export default __webpack_public_path__ + "static/media/panel_surya.54d03b3e.jpg";